import {
  MONSTER_CONTENT,
  type MapDefinition,
  type MonsterContentId,
} from "@ninja/game-content";

export interface BossEntranceMarker {
  accessId: string;
  x: number;
  y: number;
  label: string;
  detail: string;
  color: number;
}

export function bossEntranceMarkersFor(
  map: MapDefinition,
): BossEntranceMarker[] {
  if (map.regionNavigation?.role !== "field") return [];

  const accessIds = new Set(
    (map.regionSpatial?.layers.zone_access ?? [])
      .map((access) => access.properties.accessId)
      .filter((accessId): accessId is string => typeof accessId === "string"),
  );

  return (map.regionSpatial?.layers.boss_entrances ?? []).flatMap((entry) => {
    const accessId = entry.properties.accessId;
    if (typeof accessId !== "string" || !accessIds.has(accessId)) return [];

    const contentId = entry.properties.contentId;
    const boss =
      typeof contentId === "string" && contentId in MONSTER_CONTENT
        ? MONSTER_CONTENT[contentId as MonsterContentId]
        : undefined;

    return [
      {
        accessId,
        x: entry.x,
        y: entry.y,
        label: boss?.label ?? "Regional boss",
        detail: "BOSS ENTRANCE - CONFIRM TO ENTER",
        color: 0xf2b544,
      },
    ];
  });
}
